import axios from '@/plugins/axios'

/**
 * Get import status by ID
 * @param {string} importId
 * @returns {Promise<Object|null>} Import status details or null on error
 */
export async function getStatus(importId) {
  try {
    const response = await axios.get(`/v1/imports/${importId}/status`)
    return response
  } catch (error) {
    console.error('[ImportAPI] Failed to get status:', error)
    return null
  }
}

/**
 * Get import progress by ID
 * @param {string} importId
 * @returns {Promise<Object|null>} Import progress details or null on error
 */
export async function getProgress(importId) {
  try {
    const response = await axios.get(`/v1/imports/${importId}/progress`)
    return response
  } catch (error) {
    console.error('[ImportAPI] Failed to get progress:', error)
    return null
  }
}

/**
 * Get import history with optional filtering
 * @param {Object} params - Query parameters
 * @param {string} [params.status] - Filter by status (e.g., 'processing')
 * @param {number} [params.limit=1] - Number of results
 * @param {number} [params.skip=0] - Number of results to skip
 * @returns {Promise<Object|null>} Import history list or null on error
 */
export async function getImportHistory(params = {}) {
  try {
    const queryString = new URLSearchParams({
      limit: params.limit || 1,
      skip: params.skip || 0,
      ...(params.status && { status: params.status })
    }).toString()

    const response = await axios.get(`/v1/imports?${queryString}`)
    return response
  } catch (error) {
    console.error('[ImportAPI] Failed to get history:', error)
    return null
  }
}

export default {
  getStatus,
  getProgress,
  getImportHistory,
}
